module.exports = __webpack_public_path__ + "static/images/Bitmap@2x.bd7d08e.png";